<template>
    <div>
        <div class="form-row" v-for="(medication, key) in localValue" :key="key">
            <el-input v-model="localValue[key].name" @input="handleMedicationNameInput(key)" class="col-6 col-lg-4" type="text" :name="$t('form-elements.medication_name')" :label="$t('form-elements.medication_name')" :hasLabel="key === 0" :placeholder="$t('form-elements.medication_name_placeholder')"></el-input>
            <template v-if="localValue[key].name.length > 0 || key === 0">
                <el-input v-model="localValue[key].dose" @input="handleChange" class="col-6 col-lg-2" type="number" :name="$t('form-elements.medication_dose')" :hasLabel="key === 0" :label="$t('form-elements.medication_dose')" :placeholder="$t('form-elements.medication_dose_placeholder')"></el-input>
                <div class="col-12 col-lg-3">
                    <label v-if="key === 0" class="small mb-0">
                        {{ $t('form-elements.medication_avg') }}
                    </label>
                    <div class="row">
                        <el-select v-model="localValue[key].interval" @input="handleChange" class="col-5 pr-0 no-br-right" :style="(key === 0) ? 'margin-top: 7px;' : 'margin-top: 0px;'" :options="[{ value: '1', label: '1x' },{ value: '2', label: '2x' },{ value: '3', label: '3x' }]" :name="$t('form-elements.medication_avg_times')" :hasLabel="false"></el-select>
                        <el-select v-model="localValue[key].period" @input="handleChange" class="col-7 pl-0 no-br-left" :style="(key === 0) ? 'margin-top: 7px;' : 'margin-top: 0px;'" :options="[{ value: 'daily', label: $t('medication_period.daily') }, { value: 'weekly', label: $t('medication_period.weekly') }, { value: 'monthly', label: $t('medication_period.monthly') }, { value: 'rarly', label: $t('medication_period.rarly')}]" :name="$t('form-elements.medication_avg')" :hasLabel="false" :placeholder="$t('form-elements.medication_avg_placeholder')"></el-select>
                    </div>
                </div>
                <el-select v-model="localValue[key].timing" @input="handleChange" class="col-6 col-lg-3" :options="[{ value: 'morning', label: $t('general.morning') }, { value: 'midday', label: $t('general.midday') }, { value: 'evening', label: $t('general.evening') }]" :hasLabel="key === 0" :name="$t('form-elements.medication_time')" :label="$t('form-elements.medication_time')" :placeholder="$t('form-elements.medication_time_placeholder')"></el-select>
            </template>
        </div>

    </div>
</template>

<script>
import { ElInput, ElSelect } from '@/components/forms'

export default {
    inject: ['$validator'],
    components: { ElInput, ElSelect, },
    props: {
        value: {
            required: true
        },
        type: {
            required: true
        }
    },

    data() {
        return {
            localValue: this.value
        }
    },

    methods: {
        handleMedicationNameInput(key) {

            if (this.localValue[key].name.length) {
                if (!this.localValue[key + 1]) this.localValue[key + 1] = { name: '', amount: "", avg: "", time: "", medication_type_id: 1 }
            } else if (key === this.localValue.length - 2) {
                this.localValue.splice(-1, 1)
            }
            this.$forceUpdate()
            this.handleChange
        },
        handleChange() {
            this.localValue.medication_type_id = this.type
            this.$emit('input', this.localValue)
        }
    },

    watch: {
        value() {
            this.localValue = this.value;
        },
    },
};
</script>
